import portionMarkBannerLineValueTranslator from './portionMarkBannerLineValueTranslator';

// Order here is important as we want to mach inclusive marks before singular marks
// e.g. 'COSMIC TOP SECRET' before 'TOP SECRET'
const normalizeTargets = [
  'DOD UNCLASSIFIED CONTROLLED NUCLEAR INFORMATION',
  'CONTROLLED UNCLASSIFIED INFORMATION',
  'COSMIC TOP SECRET BOHEMIA',
  'COSMIC TOP SECRET ATOMAL',
  'FORMERLY RESTRICTED DATA',
  'SPECIAL ACCESS REQUIRED',
  'FOR OFFICIAL USE ONLY',
  'TALENT KEYHOLE-GEOCAP',
  'CONFIDENTIAL ATOMAL',
  'COSMIC TOP SECRET',
  'NATO CONFIDENTIAL',
  'NATO UNCLASSIFIED',
  'NATO RESTRICTED',
  'RESTRICTED DATA',
  'TALENT KEYHOLE',
  'SECRET ATOMAL',
  'CONFIDENTIAL',
  'UNCLASSIFIED',
  'NATO SECRET',
  'TOP SECRET',
  'RESTRICTED',
  'TK-GEOCAP',
  'DOD UCNI',
  'EXERCISE',
  'SECRET',
  'REL TO',
  'PROPIN',
  'NOFORN',
  'HVSACO',
  'ORCON',
  'EXDIS',
  'NODIS',
  'IMCON',
  'SIGMA',
  'SBU',
];

// This is a helper function that normalizes the text of a banner line
// into that of a portion mark. We do this because we can better parse and
// store the information when it is given as a portion mark.
export default function normalizeClassificationText(_mark: string): string {
  return normalizeTargets.reduce((mark, target) => {
    return mark.replace(
      new RegExp(target, 'g'),
      portionMarkBannerLineValueTranslator.toPortionMark(target)
    );
  }, _mark);
}
